module.exports = __webpack_public_path__ + "static/media/community.5eb50d8a.jpg";